var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpressora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.74 16.6725H19.28V17.8125H12.74V16.6725ZM12.74 19.665H19.28V20.805H12.74V19.665ZM12.74 22.6337H19.28V23.7737H12.74V22.6337Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.52 6.50751H4.48C4.22 6.50751 4 6.76876 4 7.07751V20.235C4 20.5438 4.22 20.805 4.48 20.805H8.82V30.9225C8.82 31.2313 9.04 31.4925 9.3 31.4925H22.7C22.96 31.4925 23.18 31.2313 23.18 30.9225V20.805H27.52C27.78 20.805 28 20.5438 28 20.235V7.07751C28 6.76876 27.78 6.50751 27.52 6.50751ZM22.22 30.3525H9.78V14.8438H22.22V20.7813V30.3525ZM27.04 19.665H23.18V14.8438H24.22V13.7038H7.78V14.8438H8.82V19.6413H4.96V7.64751H27.04V19.665Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.78 9.33374H17.24V10.4737H14.78V9.33374Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressora);
export default __webpack_public_path__ + "static/media/impressora.965e1baabe9e9f3e64eb5d8093051a1e.svg";
export { ForwardRef as ReactComponent };